import React, { useEffect, useRef, useState } from 'react';
import { Button, Badge, Modal, Tooltip, OverlayTrigger, } from "react-bootstrap";
import staff1 from '../../../../images/staff/member_1.png';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import axios from 'axios';

const View = ({ show, onClose, staffId }) => {
    const [attendanceData, setAttendanceData] = useState([]);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const imageBaseURL = baseURL.replace('/api', '');
    const [staffDetails, setStaffDetails] = useState(null);
    const [leaveTypes, setLeaveTypes] = useState({});
    const today = new Date();
    const formattedToday = `${String(today.getDate()).padStart(2, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${today.getFullYear()}`;

    const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    if (isNaN(date)) return dateString; // fallback if invalid date
    return `${String(date.getDate()).padStart(2,'0')}-${String(date.getMonth()+1).padStart(2,'0')}-${date.getFullYear()}`;
    };

    const attendance_type = [
        { value: "0", label: "Present", badge: "success", text: "P" },
        { value: "1", label: "Leave", badge: "danger", text: "L" },
        { value: "2", label: "Permission", badge: "warning", text: "Pr" },
        { value: "3", label: "On Duty", badge: "dark", text: "OD" },
        { value: "4", label: "Week End", badge: "info", text: "WK" },
    ];

    const getBadgeColor = (status) => {
        switch (status) {
            case "P": return "success";
            case "L": return "danger";
            case "Pr": return "warning";
            case "OD": return "dark";
            default: return "info"; // for Week End or unknown
        }
    };

    const getAttendanceInfo = (type) => {
        return attendance_type.find(a => a.value === String(type)) || { badge: "info", text: "?" };
    };

    useEffect(() => {
        if (show && staffId) {
            
            axios.get(`${baseURL}/manageattendance/staff/${staffId}`)
                .then((response) => {
                    console.log("Attendance Data Fetched:", response.data.data);
                    setAttendanceData(response.data.data);
                    
                })
                .catch((error) => {
                    console.error("Error fetching attendance:", error);
                    if (error.response?.status === 404) {
                        setAttendanceData([]);
                    }
                });

            // Fetch staff details (replace with your actual API)
            axios.get(`${baseURL}/managestaff/${staffId}`)
            .then(response => {
                setStaffDetails(response.data.data);  // assuming data contains staff details
                
            })
            .catch(error => {
                console.error("Error fetching staff details:", error);
                setStaffDetails(null);
            });
        }
    }, [show, staffId]);

    useEffect(() => {
        axios.get(`${baseURL}/manage-leavetype`)
            .then(response => {
                const leaveTypeMap = {};
                response.data.data.forEach(type => {
                    leaveTypeMap[type.sno] = type.leavetype_name;
                });
                setLeaveTypes(leaveTypeMap);
            })
            .catch(error => {
                console.error("Error fetching leave types:", error);
            });
    }, []);

    const tableRef = useRef(null);
    const [name, setName] = useState('');
    
    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                if (attendanceData && attendanceData.length > 0) 
                $(tableRef.current).DataTable({
                    "responsive": true,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
                $('.scroll_table').wrap('<div className="dataTables_scroll" />');
            }
        }
    }, [attendanceData]);


    return (
        <Modal show={show} size="xl" >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">View Attendance</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                    {/* <div>
                        <label>xxx</label>
                    </div> */}
                </div>
                <div className="modal-body">
                    <div className="row mb-2">
                        <div className="col-lg-2">
                            <div className="d-flex align-items-center">
                                <div className="avatar-preview">
                                    <img
                                        id="saveImageFile"
                                        src={staffDetails?.staff_image ? `${imageBaseURL}/storage/${staffDetails?.staff_image}` : staff1}
                                        alt={staffDetails?.employee_name}
                                        className='w-100px h-130px'
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-10">
                            <div className='row mb-3'>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Date</label>
                                    <label className='text-black fs-6 font-w500'>{formattedToday}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Name</label>
                                    <label className='text-black fs-6 font-w500'>{staffDetails?.employee_name || '-'}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Department</label>
                                    <label className='text-black fs-6 font-w500'>{staffDetails?.department?.department_name || '-'}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
                                    <label className='text-black fs-6 font-w500'>{staffDetails?.phone_no || '-'}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Email ID</label>
                                    <label className='text-black fs-6 font-w500'>{staffDetails?.mail_id || '-'}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Shift Time</label>
                                    <label className='text-black fs-6 font-w500'>{staffDetails?.shift_time?.shifttime_name || '-'}</label>
                                </div>
                            </div>

                        </div>
                        <div className='row mb-2'>
                            <div className='col-lg-12 d-flex align-items-center justify-content-end'>
                                <div className='me-2'>
                                    <Badge bg="success" className='text-white fs-8 py-0 px-2 me-2'>P</Badge>
                                    <label className='text-black fs-6'>Present</label>
                                </div>
                                {/* <div className='me-2'>
                                    <Badge bg="danger" className='text-white fs-8 py-0 px-2 me-2'>P</Badge>
                                    <label className='text-black fs-6'>Absent</label>
                                    <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Leave Without Intimation</span></Tooltip>} >
                                        <Button variant="tp-btn-light px-2 py-1" style={{ color: 'black' }}>
                                            <span><i class="fa-solid fa-circle-info fs-6 mt-1"></i></span>
                                        </Button>
                                    </OverlayTrigger>
                                </div> */}
                                <div className='me-2'>
                                    <Badge bg="danger" className='text-white fs-8 py-0 px-2 me-2'>L</Badge>
                                    <label className='text-black fs-6'>Leave</label>
                                    <OverlayTrigger trigger={['hover', 'focus']}  placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Leave With Intimation</span></Tooltip>} >
                                        <Button variant="tp-btn-light px-2 py-1" style={{ color: 'black' }}>
                                            <span><i class="fa-solid fa-circle-info fs-6 mt-1"></i></span>
                                        </Button>
                                    </OverlayTrigger>
                                </div>
                                <div className='me-2'>
                                    <Badge bg="warning" className='text-white fs-8 py-0 px-2 me-2'>Pr</Badge>
                                    <label className='text-black fs-6'>Permission</label>
                                    <OverlayTrigger trigger={['hover', 'focus']}  placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>30 M - 30 Minutes<br></br>01 H - 01 Hour<br></br>0.5 D - Half Day</span></Tooltip>} >
                                        <Button variant="tp-btn-light px-2 py-1" style={{ color: 'black' }}>
                                            <span><i class="fa-solid fa-circle-info fs-6 mt-1"></i></span>
                                        </Button>
                                    </OverlayTrigger>
                                </div>
                                <div className='me-2'>
                                    <Badge bg="dark" className='text-white fs-8 py-0 px-2 me-2'>OD</Badge>
                                    <label className='text-black fs-6'>On Duty</label>
                                    <OverlayTrigger trigger={['hover', 'focus']}  placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>30 M - 30 Minutes<br></br>01 H - 01 Hour<br></br>0.5 D - Half Day</span></Tooltip>} >
                                        <Button variant="tp-btn-light px-2 py-1" style={{ color: 'black' }}>
                                            <span><i class="fa-solid fa-circle-info fs-6 mt-1"></i></span>
                                        </Button>
                                    </OverlayTrigger>
                                </div>
                                <div className='me-2'>
                                    <Badge bg="info" className='text-white fs-8 py-0 px-2 me-2'>P</Badge>
                                    <label className='text-black fs-6'>Week End</label>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="table-container">
                                <table ref={tableRef} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                    <thead>
                                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                            <th className='min-w-50px text-start'>Date</th>
                                            <th className='min-w-100px'>Attendance</th>
                                            <th className='min-w-100px'>Timing</th>
                                            <th className='min-w-100px'>Reason</th>
                                            <th className='min-w-100px'>Leave Type</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-gray-600 fw-semibold fs-7">
                                        {attendanceData && attendanceData.length > 0 ? (
                                        attendanceData.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <label className='text-black'>{formatDate(item.date)}</label>
                                            </td>
                                            <td className='text-center'>
                                                <Badge bg={getAttendanceInfo(item.attendance_type).badge} className='text-white fs-8 py-0 px-2'>{getAttendanceInfo(item.attendance_type).text}</Badge>
                                            </td>
                                            <td>
                                                <label className='text-success font-w500 fs-7'>{item.start_time  || '-'}</label>
                                                <div className="d-block">
                                                    <label className='text-danger font-w500 fs-7'>{item.end_time  || '-'}</label>
                                                </div>
                                            </td>
                                            <td>
                                                {item.reason ? (
                                                <OverlayTrigger trigger={['hover', 'focus']}  placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'> {item.reason}</span></Tooltip>} >
                                                    <label className='text-black font-w400 fs-7 w-275px text-truncate'>
                                                        {item.reason}
                                                    </label>
                                                </OverlayTrigger>
                                                ) : '-'}
                                            </td>
                                            <td>
                                                <label>{leaveTypes[item.leave_type_id] || '-'}</label>
                                            </td>
                                        </tr>
                                        ))
                                        ) : (
                                        <tr>
                                            <td colSpan="5" className="text-center text-muted fs-6">No attendance data available</td>
                                        </tr>
                                    )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default View;
